import React, { Component } from 'react';
import { Input, Icon } from 'antd';
import { inject, observer } from 'mobx-react';
import { MagnifierIcon } from '../../../../../common/icons';
import './FullTextSearch.css';

@inject('routeTaskStore')
@observer
export default class FullTextSearch extends Component {

  constructor(props) {
    super(props);

    this.state = { searchText: '' };
  }

  search = () => {
    const { routeTaskStore } = this.props;
    routeTaskStore.setFilter('name', this.state.searchText)
  };

  keyPress = e => {
    if (e.keyCode === 13) {
      this.search();
    }
  };

  onChange = e => {
     this.setState({searchText: e.target.value});
  };

  cleanSearch = () => {
    const { routeTaskStore } = this.props;
    this.setState({searchText: ''});
    routeTaskStore.setFilter('name', '');
  };

  render() {
    const suffix = this.state.searchText ? <Icon type="close-circle" onClick={this.cleanSearch} style={{ color: 'white' }} /> : null;
    return (
      <div className="FullTextSearch">
        <Input
          placeholder={this.props.placeholder}
          prefix={<MagnifierIcon onClick={this.search} />}
          value={this.state.searchText}
          onChange={this.onChange}
          onKeyDown={this.keyPress}
          suffix={suffix}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/RouteTaskDashboard/SubHeader/FullTextSearch/FullTextSearch.js